import { render, staticRenderFns } from "./sidemenu-bookmark-button.vue?vue&type=template&id=81d95d42&scoped=true&"
import script from "./sidemenu-bookmark-button.vue?vue&type=script&lang=ts&"
export * from "./sidemenu-bookmark-button.vue?vue&type=script&lang=ts&"
import style0 from "./sidemenu-bookmark-button.vue?vue&type=style&index=0&id=81d95d42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d95d42",
  null
  
)

export default component.exports